import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TrafficLight } from './TrafficLight';
import { formatNumber, formatPercent } from '../lib/utils';
import { MapPin, TrendingUp, User } from 'lucide-react';

export const ClientCard = ({ client }) => {
  const navigate = useNavigate();
  const lastVolume = client.history?.[client.history.length - 1]?.kgs || 0;

  return (
    <div
      onClick={() => navigate(`/clientes/${client.id}`)}
      className="bg-white rounded-xl border border-slate-200 p-5 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200 cursor-pointer group"
      data-testid={`client-card-${client.id}`}
    >
      {/* Header */}
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <TrafficLight status={client.status} size="md" />
            <h3 className="font-semibold text-slate-900 truncate group-hover:text-indigo-600 transition-colors">
              {client.name}
            </h3>
          </div>
          <p className="text-xs text-slate-500">{client.industry}</p>
        </div>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-2 gap-4 mb-4">
        <div>
          <p className="text-xs text-slate-500 mb-1">Volumen Mensual</p>
          <p className="text-lg font-bold text-slate-900">{formatNumber(lastVolume)}</p>
          <p className="text-xs text-slate-400">kgs</p>
        </div>
        <div>
          <p className="text-xs text-slate-500 mb-1">Share of Wallet</p>
          <p className="text-lg font-bold text-slate-900">{formatPercent(client.share_of_wallet, 0)}</p>
          <div className="w-full h-1.5 bg-slate-100 rounded-full mt-1 overflow-hidden">
            <div 
              className="h-full bg-indigo-500 rounded-full transition-all"
              style={{ width: `${Math.min(client.share_of_wallet, 100)}%` }}
            />
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="flex items-center justify-between pt-3 border-t border-slate-100">
        <div className="flex items-center gap-1.5 text-xs text-slate-500">
          <MapPin className="w-3.5 h-3.5" />
          <span>{client.route}</span>
        </div>
        <div className="flex items-center gap-1.5 text-xs text-slate-500">
          <User className="w-3.5 h-3.5" />
          <span className="truncate max-w-[100px]">{client.executive_name}</span>
        </div>
      </div>
    </div>
  );
};
